import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { isNativeBuild } from "./lib/config";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Register service worker for PWA support with proactive updates.
//
// Skipped in the native shell: on iOS's capacitor:// scheme registration fails
// outright, and on Android it succeeds and then caches the app shell — so a
// store update could be shadowed by assets cached from the previous binary.
// The native app ships its bundle locally, so there is no offline story to lose.
if ('serviceWorker' in navigator && !isNativeBuild) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('SW registered:', registration.scope);

        // Check for updates every 5 minutes
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);
      },
      (error) => {
        console.error('SW registration failed:', error);
      }
    );

    // Auto-reload when a new SW takes control (after skipWaiting + clients.claim)
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      console.log('New SW active — reloading for update');
      window.location.reload();
    });
  });
}
